import React, { createContext, ReactNode, useMemo } from 'react';

import { IAppData } from 'client/common/types';

interface IConfig {
    avatarsHost: string;
    passportHost: string;
    tld: string;
    homeUrl: string;
    mordaHost: string;
    language: string;
    url: string;
    uatraits: {
        isMobile: boolean
    };
}

export const ConfigContext = createContext<IConfig>({
    avatarsHost: '',
    passportHost: '',
    tld: '',
    homeUrl: '',
    mordaHost: '',
    language: '',
    url: '',
    uatraits: {
        isMobile: false
    }
});

interface IConfigContextProviderProps {
    children: ReactNode;
    data: IAppData;
}

export function ConfigContextProvider({ children, data }: IConfigContextProviderProps) {
    const config = {
        avatarsHost: '',
        passportHost: data.passportHost,
        tld: data.tld,
        homeUrl: data.homeUrl,
        url: data.url,
        mordaHost: data.mordaHost,
        language: data.language,
        uatraits: data.uatraits
    };
    const configContextValue = useMemo(() => config, [config]);

    return (
        <ConfigContext.Provider value={configContextValue}>
            {children}
        </ConfigContext.Provider>
    );
}
